import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from './main/core/core.module';
import { AuthGuardService } from './main/core/services/auth-guard.service';
import { OAuthModule } from 'angular-oauth2-oidc';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';


const appRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./main/home/home.module').then(m => m.HomeModule),
        data: { title: 'Home', authorization: { permissions: [''] } }
    },
    {
        path: 'sanitize',
        loadChildren: () => import('./main/sanitize/sanitize.module').then(m => m.SanitizeModule),
        data: { title: 'Sanitize', authorization: { permissions: [''] } }
    },
    {
      path: 'artifact',
      loadChildren: () => import('./main/artifact/artifact.module').then(m => m.ArtifactModule),
      data: { title: 'artifact', authorization: { permissions: [''] } }
    },
    {
        path: 'manage-jobs',
        loadChildren: () => import('./main/manage-jobs-v2/manage-jobs.module').then(m => m.ManageJobsModule),
        data: { title: 'Manage Jobs', authorization: { permissions: [''] } },
        canActivate: [AuthGuardService],
    },
    // otherwise redirect to Home
    { path: '**', redirectTo: '' }

];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        HttpClientModule,
        CoreModule,
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),

        OAuthModule.forRoot(),

        TranslateModule.forRoot(),

        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
